import React from 'react';
import cx from 'classnames';
import { oneOf, string, object, bool } from 'prop-types';

const CLASS_ROOT = 'banner';

const propTypes = {
  type: oneOf(['coffee', 'creme', 'beige']),
  bgUrl: string,
  style: object,
  overlay: bool,
  fullWidth: bool,
  logo: string,
  svg: string,
  svgURl: string,
  fitContent: oneOf(['s']),
};

const Banner = ({
  className,
  children,
  type,
  bgUrl,
  style,
  overlay,
  logo,
  fullWidth,
  fullHeight,
  svg,
  svgUrl,
  fitContent,
  ...other
}) => {
  const classes = cx(
    CLASS_ROOT,
    {
      [`${CLASS_ROOT}--${type}`]: type,
      [`${CLASS_ROOT}--overlay`]: overlay,
      [`${CLASS_ROOT}--full-width`]: fullWidth,
      [`${CLASS_ROOT}--full-height`]: fullHeight,
      [`${CLASS_ROOT}--fit-content-${fitContent}`]: fitContent,
    },
    className,
  );

  const returnLogo = logo && (
    <svg className={`${CLASS_ROOT}__logo`} width="1000" height="500">
      <use xlinkHref={`#${logo}`} />
    </svg>
  );

  const svgImg = (svg || svgUrl) && (
    <svg className={`${CLASS_ROOT}__svg-img`} width="400" height="200">
      <use xlinkHref={svg ? `#${svg}` : svgUrl} />
    </svg>
  );

  const returnChildren = children && (
    <div className="banner__content">{children}</div>
  );

  return (
    <div
      {...bgUrl && { style: { backgroundImage: `url(${bgUrl})`, ...style } }}
      className={classes}
      {...other}
    >
      {overlay && <div className="overlay-div" />}
      {returnLogo}
      {svgImg}
      {returnChildren}
    </div>
  );
};

Banner.propTypes = propTypes;

export default Banner;
